// extracted by mini-css-extract-plugin
module.exports = {"PlayStoreButton":"styles_PlayStoreButton__Idryd"};